import gql from 'graphql-tag';

import { externalShippingAddressDetails } from '../../../../graphql/fragments/address';

const getUserForAccountCardConfigurationQuery = gql`
  query getUserForAccountCardConfiguration {
    me {
      id
      external_shipping_addresses(slice: { limit: 9999 }) {
        total
        records {
          ...externalShippingAddressDetails
        }
      }
    }
  }
  ${externalShippingAddressDetails}
`;

export default getUserForAccountCardConfigurationQuery;
